module.exports = __webpack_public_path__ + "static/flags/UY-863cf04c2d44b148d29863d448db5a86.gif";